/**
 * @generated SignedSource<<a0b72b42994bafe6e5a3c7cf27c7e4a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type KPIAnalyticsSectionSelector_KPI$data = {
  readonly activeSections: ReadonlyArray<{
    readonly assignedTeam: {
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
    } | null;
    readonly id: string;
    readonly title: string | null;
  }>;
  readonly " $fragmentType": "KPIAnalyticsSectionSelector_KPI";
};
export type KPIAnalyticsSectionSelector_KPI$key = {
  readonly " $data"?: KPIAnalyticsSectionSelector_KPI$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIAnalyticsSectionSelector_KPI">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIAnalyticsSectionSelector_KPI",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoutineSection",
      "kind": "LinkedField",
      "name": "activeSections",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Team",
          "kind": "LinkedField",
          "name": "assignedTeam",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "icon",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KPI",
  "abstractKey": null
};
})();

(node as any).hash = "2dada0b271a2ea836fd831729d53fa2a";

export default node;
